import { render, staticRenderFns } from "./TableTask.vue?vue&type=template&id=063d6772&scoped=true"
import script from "./TableTask.vue?vue&type=script&lang=js"
export * from "./TableTask.vue?vue&type=script&lang=js"
import style0 from "./TableTask.vue?vue&type=style&index=0&id=063d6772&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063d6772",
  null
  
)

export default component.exports